import React from 'react';
import { Tooltip } from '@mui/material';
import { Pdf, Doc } from 'Images/index';
import { FILE_EXTENSIONS } from 'Constants/General';
import CloseIcon from '@mui/icons-material/Close';
import { s3 } from 'Services/AWS/s3';
import { CardContainer, IconContaniner, IconCloseContaniner, InfoContainer, Title, Size, Image } from './style';

export default function DocumentCard({
  fileName = '',
  fileExtension = '',
  size = '',
  fileLocation = '',
  isThereButtonClose = false,
  onClose = null,
  document = {
    key: '',
    size: 0,
    fileName: '',
  },
}) {
  const { PDF, DOC, DOCX } = FILE_EXTENSIONS;
  const iconOptions = {
    [PDF]: Pdf,
    [DOC]: Doc,
    [DOCX]: Doc,
  };
  const defaultIcon = DOC;

  const getFileData = async () => {
    // Si no se proporciona la ubicación del archivo, no se puede descargar.
    if (!fileLocation) {
      return {};
    }

    // Mandamos a generar una URL firmada para el archivo.
    const response = await s3.getSignedUrl(fileLocation);

    // Si no se obtiene una respuesta, no se puede descargar.
    if (!response) {
      return {};
    }

    // Retornamos la URL firmada para que el usuario pueda descargar el archivo.
    // El tiempo máximo de vida de la URL firmada es de 1 hora.
    return {
      href: response?.signedUrl,
      download: fileName,
      target: '_blank',
    };
  };

  return (
    <CardContainer
      onClick={async () => {
        const data = await getFileData();
        window.open(data.href, data.target);
      }}
    >
      {isThereButtonClose ? (
        <IconCloseContaniner>
          <CloseIcon fontSize="small" style={{ color: 'white' }} onClick={() => onClose()} />
        </IconCloseContaniner>
      ) : null}
      <IconContaniner>
        <img style={Image} src={iconOptions[fileExtension]} />
      </IconContaniner>
      <InfoContainer>
        <Tooltip title={fileName}>
          <div style={Title}>{fileName.length > 20 ? `${fileName.slice(0, 17)}....${fileExtension}` : fileName}</div>
        </Tooltip>
        <div style={Size}>{size}</div>
      </InfoContainer>
    </CardContainer>
  );
}
